import React from "react";

import i18n from "../../../../constants/i18n";
import styles from "./BlockPhotoProcessingFailureModal.module.scss";

const BlockPhotoProcessingFailureModalView = ({
    failedPhotos,
    hideModal,
    isRemoving,
    isVisible,
    onEditBlock,
    onRemoveFailedPhotos,
}) => (
    <div className={`modal ${isVisible ? "is-active" : ""}`}>
        <div className="modal-background" />
        <div className={`modal-card ${styles.modalCard}`}>
            <header className="modal-card-head">
                <h2 className="modal-card-title has-text-primary">
                    {i18n.blockPhotoProcessingFailureModal.title}
                </h2>
                <button
                    onClick={hideModal}
                    className="delete"
                    aria-label="close"
                />
            </header>
            <section className="modal-card-body">
                <p>{i18n.blockPhotoProcessingFailureModal.body}</p>
                <ul className={styles.failedPhotos}>
                    {failedPhotos.map((photo) => (
                        <li key={photo.id}>- {photo.originalFileName}</li>
                    ))}
                </ul>
            </section>
            <footer className="modal-card-foot">
                <button
                    onClick={onEditBlock}
                    disabled={isRemoving}
                    className="button is-primary is-rounded"
                >
                    {i18n.blockPhotoProcessingFailureModal.editButtonLabel}
                </button>
                <button
                    onClick={onRemoveFailedPhotos}
                    disabled={isRemoving || failedPhotos.length === 0}
                    className="button is-danger is-rounded"
                >
                    {i18n.blockPhotoProcessingFailureModal.removeButtonLabel}
                </button>
            </footer>
        </div>
    </div>
);

export default BlockPhotoProcessingFailureModalView;
